import { createAsyncThunk } from '@reduxjs/toolkit';
import userService from '../../../api/services/user';

export const fetchUserInfo = createAsyncThunk('user/fetch-user-info', async requestData => {
  return await userService.fetchInfo(requestData);
});

export const verifyEmail = createAsyncThunk('user/verify-email', async requestData => {
  return await userService.verifyEmail(requestData);
});

export const getDeliveryUsers = createAsyncThunk('user/getDeliveryUsers', async requestData => {
  return await userService.getDeliveryUsers(requestData);
});
